import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class ProductApi {
  static async CreateProduct(data: {
    name: string;
    description: string;
    partNumber: string;
    familyId: string | undefined;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).post("/products", data);
    return response.data;
  }

  static async UpdateProduct(data: {
    id: string;
    name: string;
    description: string;
    partNumber: string;
    isProducible: boolean;
    familyId: string;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).put(
      `/products/${data.id}`,
      data,
    );
    return response.data;
  }

  static async DeleteProduct(id: string): Promise<any> {
    const response = await ApiHandler(baseURL).delete(`/products/${id}`);
    return response;
  }

  static async GetById(id: string): Promise<any> {
    const response = await ApiHandler(baseURL).get(`/products/${id}`);
    return response.data;
  }
  static async GetAll(): Promise<any> {
    const response = await ApiHandler(baseURL).get("/products");
    return response;
  }

  static async GetProductsByFilterAsync(
  pageNumber: number = 1,
  pageSize: number = 10,
  sortField: string = "name",
  sortDirection: string = "asc",
  partNumber?: string,
  name?: string,
  description?: string,
  familyIds: string[] = [],
  isProducible?: boolean,
  plantIds: string[] = []
): Promise<any> {
  let url = `/products/filter?`;

  url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
  url += `&sortField=${encodeURIComponent(sortField)}`;
  url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

  if (partNumber) url += `&partNumber=${encodeURIComponent(partNumber)}`;
  if (name) url += `&name=${encodeURIComponent(name)}`;
  if (description) url += `&description=${encodeURIComponent(description)}`;
  if (isProducible !== undefined) url += `&isProducible=${isProducible}`;

  familyIds.forEach((id) => {
    if (id) url += `&familyIds=${encodeURIComponent(id)}`;
  });

  plantIds.forEach((id) => {
    if (id) url += `&plantIds=${encodeURIComponent(id)}`;
  });

  return ApiHandler(baseURL).get(url);
}

  static async GetProductsByLine(lineId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/products/by-line/${encodeURIComponent(lineId)}`);
  }
}
